import styled from 'styled-components';

export const BaseInput = styled.input`
  &:focus {
    top: 8px;
  }
`;

export const Container = styled.div<{ disabled?: boolean }>`
  display: flex;
  position: relative;
  & > div {
    flex: 1;
  }
  & > span {
    position: absolute;
    right: 16px;
    bottom: 0;
    top: 0;
    margin: auto;
    height: 16px;
    opacity: ${(p) => (p.disabled ? 0.4 : 1)};
  }
`;
